// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { correlatedFetch } from '@/clients/correlatedFetch';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      autoRefreshToken: true,
      persistSession: true,
    },
    // FIN-865: supabase-js forwards this same fetch to both its PostgREST (rest/v1) and
    // Functions (functions/v1) sub-clients — correlatedFetch.ts scopes itself to those two
    // paths and passes everything else through untouched.
    global: { fetch: correlatedFetch },
  }
);
